/**
 * @author A.Pelev
 *
 * Resource loader class.
 * Responsible for initial loading of required assets.
 */
import TextField from "../views/components/TextField";
import GameModel from "../../src/model/GameModel";

export class GameLoader {
    private pixiLoader: PIXI.loaders.Loader;
    public defaultLang = "en";
    // private urlParams; // TODO it is possible this data to come as http response, not as urlParams
    private version;

    constructor() {
        this.pixiLoader = PIXI.loader;
        // this.urlParams = gameModel;
        this.version = GameModel.version;
    }

    public loadLocalization(localizedAssetList, callback) {
        let localizationName = "localization_en";
        GameModel.lang = GameModel.lang.toLowerCase();

        if (localizedAssetList[GameModel.lang]) {
            if (GameModel.lang != this.defaultLang) {
                localizationName = "localization_" + GameModel.lang;
            }
            this.queueResources(localizedAssetList[GameModel.lang]);
        } else {
            this.queueResources(localizedAssetList[this.defaultLang]);
        }
        // this.pixiLoader.add("localization", "assets/locale/" + localizationName + ".json");
        this.pixiLoader.load(callback);
    }

    // should be refactored
    public loadFonts(gameConfig: any) {
        let style = document.createElement("style");
        let fontsToLoad = {};
        let fontConfig = {
            defaultFonts: gameConfig.defaultFonts,
            gameFonts: gameConfig.fonts,
            languageFont: gameConfig.fontMap[GameModel.lang],
        };

        let baseUrl = this.pixiLoader.baseUrl ? this.pixiLoader.baseUrl : "./";

        for (let fontName in fontConfig.defaultFonts) {
    
            fontsToLoad[fontName] = {
                url:
                baseUrl + "core/assets/fonts/" +
                    fontConfig.defaultFonts[fontName].url +
                    "?version=" +
                    this.version,
                format: fontConfig.defaultFonts[fontName].format
                    ? fontConfig.defaultFonts[fontName].format
                    : "truetype",
            };
            TextField.fontMeasure[fontName] = {
                text:
                    fontConfig.defaultFonts[fontName].measureText ||
                    gameConfig.defaultMeasureText,
                baseline:
                    fontConfig.defaultFonts[fontName].measureBaseline ||
                    gameConfig.defaultMeasureBaseline,
            };
        }

        for (let fontName in fontConfig.gameFonts) {
        
            fontsToLoad[fontName] = {
                url:
                baseUrl + "assets/fonts/" +
                    fontConfig.gameFonts[fontName].url +
                    "?version=" +
                    this.version,
                format: fontConfig.gameFonts[fontName].format
                    ? fontConfig.gameFonts[fontName].format
                    : "truetype",
            };
            TextField.fontMeasure[fontName] = {
                text:
                    fontConfig.gameFonts[fontName].measureText ||
                    gameConfig.defaultMeasureText,
                baseline:
                    fontConfig.gameFonts[fontName].measureBaseline ||
                    gameConfig.defaultMeasureBaseline,
            };
        }

        for (let fontName in fontsToLoad) {
            if (fontConfig.languageFont) {
                fontsToLoad[fontName] = {
                    url: "core/assets/fonts/" + fontConfig.languageFont.url,
                    format: fontConfig.languageFont.format
                        ? fontConfig.languageFont.format
                        : "truetype",
                };
                TextField.fontMeasure[fontName] = {
                    text:
                        fontConfig.languageFont.measureText ||
                        gameConfig.defaultMeasureText,
                    baseline:
                        fontConfig.languageFont.measureBaseline ||
                        gameConfig.defaultMeasureBaseline,
                };
            }
            style.innerHTML +=
                "@font-face{" +
                "  font-family: " +
                fontName +
                ";" +
                "  src: url('" +
                fontsToLoad[fontName].url +
                "')" +
                "       format('" +
                fontsToLoad[fontName].format +
                "');" +
                "  font-display: block;" +
                "}";

            let p = document.createElement("p");
            p.innerHTML = "abc123";
            p.style.fontFamily = fontName;
            p.style.position = "fixed";
            p.style.bottom = "100%";
            document.getElementsByTagName("body")[0].appendChild(p);
        }
        document.getElementsByTagName("head")[0].appendChild(style);
    }

    public loadAssets(
        assetList,
        callback?: (...args: any[]) => void,
        onProgress?: (...args: any[]) => void
    ) {
        this.queueResources(assetList);
        this.pixiLoader.load(() => {
            this.secondaryLoad(callback);
        });

        if (onProgress) {
            this.pixiLoader.onLoad.add(onProgress, this);
        }
    }

    private queueResources(resourceList: any, options?: any) {
        for (let i = 0; i < resourceList.length; i++) {
            if (this.version) {
                this.pixiLoader.add(
                    resourceList[i][0],
                    resourceList[i][1] + "?version=" + this.version,
                    options
                );
            } else {
                this.pixiLoader.add(
                    resourceList[i][0],
                    resourceList[i][1],
                    options
                );
            }
        }
    }

    public get loader() {
        return this.pixiLoader;
    }

    public get config() {
        return this.pixiLoader.resources.asset_config.data;
    }

    public loadConfig(configArr: string[][], callback) {
        this.queueResources(configArr);
        this.pixiLoader.load(callback);
    }

    // public loadLayoutConfig(configArr: string[][], callback) {
    //     this.queueResources(configArr);
    //     this.pixiLoader.load(callback);
    // }

    protected secondaryLoad(callback?: (...args: any[]) => void) {
        for (const atlasName in this.pixiLoader.resources) {
            const atlas = this.pixiLoader.resources[atlasName];
            if (
                atlas.data &&
                atlas.data.meta &&
                atlas.data.meta.related_multi_packs
            ) {
                for (const pack in atlas.data.meta.related_multi_packs) {
                    let url = atlas.url.slice(0, atlas.url.indexOf(atlas.name));
                    if (
                        this.pixiLoader.baseUrl &&
                        this.pixiLoader.baseUrl.length
                    ) {
                        url = url.replace(this.pixiLoader.baseUrl, "");
                    }
                    const assetName = atlas.data.meta.related_multi_packs[pack];
                    console.log(url,assetName);
                    if(!this.pixiLoader.resources[assetName]) {
                        if (this.version) {
                            this.pixiLoader.add(
                                assetName,
                                url + assetName + "?version=" + this.version
                            );
                        } else {
                            this.pixiLoader.add(assetName, url + assetName);
                        }
                    }
                }
            }
        }
        callback ? this.pixiLoader.load(callback) : this.pixiLoader.load();
    }

    public loadSoundAssets(assetList, callback?: (...args: any[]) => void) {
        const type = { loadType: "XHR", xhrType: "blob" };
        this.queueResources(assetList, type);
        this.pixiLoader.load(callback);
    }
}

export default new GameLoader();
